import React, { useState, useEffect } from "react";

import { UserContext } from "./contexts/userContext";
import Landing from "./components/landing/landing";
import Login from "./components/login/login";
import Logout from "./components/logout/logout";
import Recuperar from "./components/recuperar/recuperar";
import Admin from "./components/admin/admin";
import { Route, Routes, Navigate } from "react-router-dom";
import { InstallPWA } from "./installPWA/installPWA";
import { getUser } from "./services/userService";
import jwtDecode from "jwt-decode";
import { isMobile } from "react-device-detect";
import { toastBigError } from "components/utils/toasts";
// import * as rdd from "react-device-detect";
import EquiposForm from "components/equipos/equiposForm";
import "App.css";
import PreLoader from "./components/preloader/preloader";
import ResetPassword from "./components/recuperar/resetPassword";
import TorneosPublico from "components/torneosPublico/torneosPublico";
import NoticiasPublico from "components/noticiasPublico/noticiasPublico";
import NoticiaDetalle from "components/noticiasPublico/noticiaDetalle";
import { regSw, subscribe } from "./registerSW";
import FooterBlackSocial from "components/footers/FooterBlackSocial.js";
import ScrollTransparentNavbar from "components/navbars/ScrollTransparentNavbar.js";

function App() {
  // rdd.isMobile = true;
  // "booting" bloquea el render de las rutas hasta resolver el usuario.
  // "pendingLoads" cuenta las páginas que están trayendo datos: es un contador
  // (no un booleano) para que dos cargas simultáneas no se pisen entre sí.
  const [booting, setBooting] = useState(true);
  const [pendingLoads, setPendingLoads] = useState(0);
  const [user, setUser] = useState(null);

  const isLoading = booting || pendingLoads > 0;

  // let usuario = null;

  const token = localStorage.getItem("token");

  const loading = () => {
    setPendingLoads((n) => n + 1);
  };

  const doneLoading = () => {
    setPendingLoads((n) => (n > 0 ? n - 1 : 0));
  };

  useEffect(() => {
    if (token) fetchUser(token);
    else setBooting(false);
  }, []);

  const fetchUser = async (jwt) => {
    const decoded = jwt ? jwtDecode(jwt) : null;
    try {
      let usuario = await getUser(decoded.user._id);
      if (!usuario || usuario.length === 0) {
        localStorage.removeItem("token");
      }
      if (usuario === "NETWORK ERROR") {
        toastBigError("ERROR DE CONEXION");
        console.log("ERROR: Error de Conexión 1");
        // usuario = null;
        setUser(null);
        // localStorage.removeItem("token");
      }
      setUser(usuario);
      setBooting(false);
    } catch {
      toastBigError("ERROR DE CONEXION");
      // usuario = null;
      setUser(null);
      console.log("ERROR: Error de Conexión 2");
      // localStorage.removeItem("token");
      setBooting(false);
    }

    // PWA
    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: https://cra.link/PWA
    const registerAndSubscribe = async (user) => {
      try {
        const serviceWorkerReg = await regSw();
        let subscription = await subscribe(serviceWorkerReg, user);
      } catch (error) {
        console.log(error);
      }
    };

    registerAndSubscribe(user);
  };

  return (
    <>
      <InstallPWA />
      <div className={isLoading ? "page-loading" : ""}>
        {/* El preloader va por encima de las rutas (overlay), no en lugar de
            ellas: si desmontáramos el árbol, la página que está cargando
            moriría a mitad del fetch y nunca llamaría a onDoneLoading. */}
        {isLoading && <PreLoader />}

        {!booting &&
          (user && user.profile ? (
            user.profile.isAdmin ? (
              <>
                <UserContext.Provider value={user ? user : null}>
                  <Routes>
                    <Route path="/logout" element={<Logout onLoading={loading} onDoneLoading={doneLoading} />} />
                    <Route
                      path="/equipos/:id/:nombre"
                      element={<EquiposForm onLoading={loading} onDoneLoading={doneLoading} />}
                    />
                    <Route path="/admin/*" element={<Admin onLoading={loading} onDoneLoading={doneLoading} />} />
                    <Route path="*" element={<Navigate to="/admin" replace />} />
                  </Routes>
                </UserContext.Provider>
              </>
            ) : (
              // )
              <></> /*User no admin*/
            )
          ) : (
            <UserContext.Provider value={user ? user : null}>
              <ScrollTransparentNavbar />
              <Routes>
                <Route path="/login" element={<Login onLoading={loading} onDoneLoading={doneLoading} />} />
                <Route path="/logout" element={<Logout onLoading={loading} onDoneLoading={doneLoading} />} />
                <Route path="/recuperar" element={<Recuperar onLoading={loading} onDoneLoading={doneLoading} />} />
                <Route
                  path="/resetpassword/:id/:token"
                  element={<ResetPassword onLoading={loading} onDoneLoading={doneLoading} />}
                />
                <Route
                  path="/landing"
                  user={user}
                  element={<Landing onLoading={loading} onDoneLoading={doneLoading} />}
                />
                <Route
                  path="/torneos"
                  element={<TorneosPublico onLoading={loading} onDoneLoading={doneLoading} />}
                />
                <Route
                  path="/noticias"
                  element={<NoticiasPublico onLoading={loading} onDoneLoading={doneLoading} />}
                />
                <Route
                  path="/noticias/:id"
                  element={<NoticiaDetalle onLoading={loading} onDoneLoading={doneLoading} />}
                />
                <Route path="*" element={<Navigate to="/torneos" replace />} />
              </Routes>
              <FooterBlackSocial />
            </UserContext.Provider>
          ))}
      </div>
    </>
  );
}

export default App;
